module.exports = __webpack_public_path__ + "static/media/EliminarPages.24f8c22a.svg";